module.exports = __webpack_public_path__ + "img/header-engagementRingsWhitegold.39440d0.webp";